import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Setup from "@/pages/Setup";
import Dashboard from "@/pages/Dashboard";
import Inventario from "@/pages/Inventario";
import Cobrar from "@/pages/Cobrar";
import Fiados from "@/pages/Fiados";
import Reporte from "@/pages/Reporte";
import Login from "@/pages/Login";
import Receipt from "@/pages/Receipt";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCatalogo from "@/pages/AdminCatalogo";
import GuiaPistola from "@/pages/GuiaPistola";
import PaymentResult from "@/pages/PaymentResult";
import Pagar from "@/pages/Pagar";
import Terminos from "@/pages/legal/Terminos";
import Privacidad from "@/pages/legal/Privacidad";
import Domicilio from "@/pages/Domicilio";
import EntregaPublic from "@/pages/EntregaPublic";
import Catalogo from "@/pages/Catalogo";
import PreciosIniciales from "@/pages/PreciosIniciales";
import InventarioInicial from "@/pages/InventarioInicial";
import Mesas from "@/pages/Mesas";
import PreciosExpress from "@/pages/PreciosExpress";
import { getStore, getUser } from "@/lib/api";

function RequireStore({ children }) {
  const store = getStore();
  if (!store?.id) return <Navigate to="/setup" replace />;
  const user = getUser();
  if (!user?.id) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch(() => {});
      });
    }
  }, []);
  return (
    <div className="App" data-testid="chalann-app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<RequireStore><Dashboard /></RequireStore>} />
          <Route path="/inventario" element={<RequireStore><Inventario /></RequireStore>} />
          <Route path="/cobrar" element={<RequireStore><Cobrar /></RequireStore>} />
          <Route path="/fiados" element={<RequireStore><Fiados /></RequireStore>} />
          <Route path="/reporte" element={<RequireStore><Reporte /></RequireStore>} />
          <Route path="/receipt/:saleId" element={<Receipt />} />
          <Route path="/entrega/:storeId" element={<EntregaPublic />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/catalogo" element={<AdminCatalogo />} />
          <Route path="/pagar" element={<RequireStore><Pagar /></RequireStore>} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route path="/guia" element={<GuiaPistola />} />
          <Route path="/guia-pistola" element={<GuiaPistola />} />
          <Route path="/domicilio" element={<RequireStore><Domicilio /></RequireStore>} />
          <Route path="/catalogo" element={<RequireStore><Catalogo /></RequireStore>} />
          <Route path="/precios-iniciales" element={<RequireStore><PreciosIniciales /></RequireStore>} />
          <Route path="/inventario-inicial" element={<RequireStore><InventarioInicial /></RequireStore>} />
          <Route path="/mesas" element={<RequireStore><Mesas /></RequireStore>} />
          <Route path="/precios-express" element={<RequireStore><PreciosExpress /></RequireStore>} />
          <Route path="/legal/terminos" element={<Terminos />} />
          <Route path="/legal/privacidad" element={<Privacidad />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
